if (!customElements.get('nc-prairie-builder')) {
  customElements.define('nc-prairie-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.products = config.products;
      this.specifications = config.specifications || [[30,12.569,110.71],[21,1.352,21.83],[23,.648,5.89]];
      this.speciesGroups = {"achillea millefolium":"Forbs & flowering shrubs","allium cernuum":"Forbs & flowering shrubs","amorpha canescens":"Forbs & flowering shrubs","andropogon gerardii":"Grasses","anemone canadensis":"Forbs & flowering shrubs","anemone cylindrica":"Forbs & flowering shrubs","asclepias syriaca":"Forbs & flowering shrubs","asclepias tuberosa":"Forbs & flowering shrubs","asclepias verticillata":"Forbs & flowering shrubs","astragalus canadensis":"Forbs & flowering shrubs","baptisia alba":"Forbs & flowering shrubs","baptisia bracteata":"Forbs & flowering shrubs","bouteloua curtipendula":"Grasses","brickellia eupatorioides":"Forbs & flowering shrubs","bromus kalmii":"Grasses","cacalia atriplicifolia":"Forbs & flowering shrubs","carex bicknellii":"Sedges & rushes","carex brevior":"Sedges & rushes","carex molesta":"Sedges & rushes","chamaecrista fasciculata":"Forbs & flowering shrubs","coreopsis palmata":"Forbs & flowering shrubs","coreopsis tripteris":"Forbs & flowering shrubs","dalea candida":"Forbs & flowering shrubs","dalea purpurea":"Forbs & flowering shrubs","desmanthus illinoensis":"Forbs & flowering shrubs","desmodium canadense":"Forbs & flowering shrubs","desmodium illinoense":"Forbs & flowering shrubs","dodecatheon meadia":"Forbs & flowering shrubs","echinacea pallida":"Forbs & flowering shrubs","elymus canadensis":"Grasses","elymus virginicus":"Grasses","eryngium yuccifolium":"Forbs & flowering shrubs","euphorbia corollata":"Forbs & flowering shrubs","euthamia graminifolia":"Forbs & flowering shrubs","gentiana flavida":"Forbs & flowering shrubs","heliopsis helianthoides":"Forbs & flowering shrubs","juncus tenuis":"Sedges & rushes","koeleria macrantha":"Grasses","lespedeza capitata":"Forbs & flowering shrubs","liatris aspera":"Forbs & flowering shrubs","liatris pycnostachya":"Forbs & flowering shrubs","liatris scariosa":"Forbs & flowering shrubs","monarda fistulosa":"Forbs & flowering shrubs","panicum virgatum":"Grasses","parthenium integrifolium":"Forbs & flowering shrubs","pedicularis canadensis":"Forbs & flowering shrubs","penstemon digitalis":"Forbs & flowering shrubs","polygonatum biflorum":"Forbs & flowering shrubs","pycnanthemum tenuifolium":"Forbs & flowering shrubs","pycnanthemum virginianum":"Forbs & flowering shrubs","ratibida pinnata":"Forbs & flowering shrubs","rudbeckia hirta":"Forbs & flowering shrubs","ruellia humilis":"Forbs & flowering shrubs","schizachyrium scoparium":"Grasses","silphium integrifolium":"Forbs & flowering shrubs","silphium laciniatum":"Forbs & flowering shrubs","silphium terebinthinaceum":"Forbs & flowering shrubs","sisyrinchium angustifolium":"Forbs & flowering shrubs","solidago juncea":"Forbs & flowering shrubs","solidago nemoralis":"Forbs & flowering shrubs","solidago rigida":"Forbs & flowering shrubs","solidago speciosa":"Forbs & flowering shrubs","sorghastrum nutans":"Grasses","sphenopholis obtusata":"Grasses","sporobolus heterolepis":"Grasses","symphyotrichum ericoides":"Forbs & flowering shrubs","symphyotrichum laeve":"Forbs & flowering shrubs","symphyotrichum novae-angliae":"Forbs & flowering shrubs","symphyotrichum oolentangiense":"Forbs & flowering shrubs","tradescantia ohiensis":"Forbs & flowering shrubs","verbena hastata":"Forbs & flowering shrubs","veronicastrum virginicum":"Forbs & flowering shrubs","zizia aptera":"Forbs & flowering shrubs","zizia aurea":"Forbs & flowering shrubs"};
      this.recipeRows = JSON.parse(this.querySelector('[data-species]')?.textContent || '[]');
      this.componentIndexes = this.dataset.optionalBase === 'true' ? [0,1,2] : [this.products[0]?.handle?.startsWith('expanded-') ? 1 : this.products[0]?.handle?.startsWith('maximum-') ? 2 : 0];
      this.words = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type=submit]');
      this.status = this.querySelector('[data-status]');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      const requestedId = new URLSearchParams(window.location.search).get('variant');
      const initialId = requestedId || this.dataset.initialVariant;
      const initial = this.products[0]?.variants?.find(v => String(v.id) === initialId);
      const initialTenths = this.coverageOf(initial);
      const coverage = this.querySelector('[name=coverage_size]');
      if (initial?.title === '1,000 sq ft') coverage.value = 'packet';
      else if (initialTenths === 2.5) coverage.value = 'quarter';
      else if (Number.isInteger(initialTenths) && initialTenths >= 5 && initialTenths <= 50) {
        coverage.value = 'other';
        this.querySelector('[name=acreage]').value = String(initialTenths / 10);
      }
      else if (initialId) {
        const option = document.createElement('option'); option.value=''; option.textContent=this.words.unsupportedInitial;
        coverage.prepend(option); coverage.value=''; this.unsupportedInitial=true;
      }
      coverage.addEventListener('change', () => {this.unsupportedInitial=false;});
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => {event.preventDefault(); this.submit();});
      this.organizeDetails();
      this.setupSelectedHighlights();
      this.setupAccordionIcons();
      this.update();
    }
    organizeDetails() {
      const scope = this.closest('product-info') || this.closest('.shopify-section') || this.parentElement;
      const copy = scope.querySelector('.nc-product-copy');
      if (!copy || copy.dataset.organized === 'true') return;
      const headings = this.words.detailGroups?.split('|');
      if (!headings || headings.length !== 7) return;
      const nodes = Array.from(copy.childNodes);
      const groups = headings.map((heading, index) => {
        const wrapper = document.createElement('div'); wrapper.className = 'product__accordion accordion nc-prairie__content-group';
        const details = document.createElement('details'); details.id = 'PrairieDetails-' + this.dataset.sectionId + '-' + index;
        const summary = document.createElement('summary');
        const title = document.createElement('div'); title.className = 'summary__title';
        const h = document.createElement('h2'); h.className = 'h4 accordion__title inline-richtext'; h.textContent = index === 1 ? 'Compare mix components' : heading; title.append(h); summary.append(title);
        const caret = this.querySelector('.nc-prairie__selection-details .icon-caret');
        if (caret) summary.append(caret.cloneNode(true));
        const body = document.createElement('div'); body.className = 'accordion__content rte';
        details.append(summary, body); wrapper.append(details);
        return {wrapper, body, details};
      });
      let group = 0;
      let inCircle = false;
      const circle = document.createElement('section');
      circle.className = 'nc-prairie__stewardship-circle';
      const routes = {
        'Choose the diversity that fits your project': 1,
        'Site conditions': 0,
        'Coverage sizes and 1,000 sq ft specifications': 3,
        'Blend ingredients': 2,
        'Why these species belong in the planting': 2,
        'Informed by established ecological restoration practice': 4,
        'Make your restoration budget go further': 4,
        'Planting and establishment': 5,
        'Ordering details': 5
      };
      nodes.forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'STYLE') return;
        if (node.nodeType === 1 && node.tagName === 'H2') {
          inCircle = node.textContent.trim() === 'Make your restoration budget go further';
        }
        if (inCircle) { circle.append(node); return; }
        if (node.nodeType === 1 && node.id === 'mix-specifications') group = 6;
        else if (node.nodeType === 1 && node.tagName === 'H2' && Object.hasOwn(routes, node.textContent.trim())) group = routes[node.textContent.trim()];
        groups[group].body.append(node);
      });
      const diversityGuidance = this.querySelector('[data-intro-diversity]');
      if (diversityGuidance) groups[4].body.prepend(diversityGuidance);
      const selectedDetails = this.querySelector('[data-selected-details]');
      const selectedBody = selectedDetails?.querySelector('.accordion__content');
      const componentReference = scope.querySelector('.nc-prairie__reference');
      const consolidateSpecs = !!selectedBody;
      groups.forEach(({wrapper, body}, index) => {
        if ((index === 2 || index === 6) && consolidateSpecs) return;
        if (body.textContent.trim()) copy.append(wrapper);
        if (index === 4 && circle.textContent.trim()) copy.append(circle);
      });
      if (consolidateSpecs) {
        selectedDetails.id = 'mix-specifications';
        if (componentReference) {
          const broken = componentReference.querySelector('a[href="/pages/mixed-height-native-prairie-seed-mix-specifications"]');
          if (broken) componentReference.remove();
          else selectedBody.append(componentReference);
        }
        const help = Array.from(selectedBody.querySelectorAll(':scope > p')).find(p => p.textContent.includes('The table below updates with your selected seed components.'));
        if (help) help.textContent = 'The table updates with your selected seed components. Seeds/sq ft shows each species’ seed density. Percentage by seed count is its share of the total seeds in all currently selected components combined, calculated from the supplier’s rounded seeds/sq ft figures, not seed weight. Percentages are approximate and may not sum to exactly 100% after rounding. Coverage and package quantity change the total PLS amount above, not these rates or proportions.';
      }
      if (selectedDetails) {
        const summary = selectedDetails.querySelector('summary');
        summary.classList.add('nc-prairie__spec-toggle');
        summary.setAttribute('aria-controls', 'PrairieSpecifications-' + this.dataset.sectionId);
        selectedBody.id = 'PrairieSpecifications-' + this.dataset.sectionId;
        const syncExpanded = () => summary.setAttribute('aria-expanded', String(selectedDetails.open));
        selectedDetails.addEventListener('toggle', syncExpanded);
        syncExpanded();
        const availability = scope.querySelector('[data-seed-mix-availability]');
        if (availability) {
          const label = availability.querySelector('strong');
          if (label) label.textContent = 'Composition and availability*';
          selectedBody.append(availability);
        }
        copy.querySelectorAll('a.nc-mix-spec-button[href="#mix-specifications"]').forEach(anchor => {
          const parent = anchor.parentElement;
          anchor.remove();
          if (parent.tagName === 'P' && !parent.textContent.trim()) parent.remove();
        });
      }
      copy.dataset.organized = 'true';
      const optionalPlanner = scope.querySelector('.nc-prairie-planner');
      const descriptionBlock = copy.closest('.product__description');
      if (optionalPlanner && descriptionBlock) descriptionBlock.after(optionalPlanner);
      const revealAnchor = () => {
        if (!window.location.hash) return;
        let id; try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
        const target = document.getElementById(id);
        if (!target || !scope.contains(target)) return;
        if (target.tagName === 'DETAILS') target.open = true;
        for (let ancestor = target.parentElement; ancestor && ancestor !== scope; ancestor = ancestor.parentElement) if (ancestor.tagName === 'DETAILS') ancestor.open = true;
        target.scrollIntoView({block:'start'});
      };
      copy.addEventListener('click', event => {
        const anchor = event.target.closest('a[href^="#"]');
        if (anchor) requestAnimationFrame(revealAnchor);
      });
      window.addEventListener('hashchange', revealAnchor);
      revealAnchor();
    }
    setupSelectedHighlights() {
      const scope = this.closest('product-info') || this.parentElement;
      const specs = this.querySelector('.nc-prairie__selection-details');
      if (!specs) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'product__accordion accordion nc-prairie__selected-highlights';
      wrapper.dataset.selectedHighlights = '';
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const title = document.createElement('h2');
      title.className = 'h4 accordion__title inline-richtext';
      title.textContent = 'Meet the Standout Plants';
      summary.append(title);
      const caret = specs.querySelector('.icon-caret');
      if (caret) summary.append(caret.cloneNode(true));
      const body = document.createElement('div');
      body.className = 'accordion__content rte product__description';
      const expectation = document.createElement('p');
      expectation.textContent = 'These highlights describe established plants on suitable sites; they do not guarantee germination, abundance or wildlife visits.';
      body.append(expectation);
      this.highlightPanels = this.products.map((product, index) => {
        const source = new DOMParser().parseFromString(product?.description || '', 'text/html');
        const highlights = Array.from(source.querySelectorAll('.nc-prairie-highlights'));
        const panel = document.createElement('section');
        panel.dataset.highlightComponent = String(index);
        const label = document.createElement('h3');
        label.textContent = product?.title || this.words.names[this.componentIndexes[index]];
        panel.append(label);
        highlights.forEach(highlight => {
          const content = highlight.querySelector('.accordion__content');
          if (!content) return;
          const category = highlight.querySelector('summary h2');
          if (highlights.length > 1 && category) {
            const h = document.createElement('h4'); h.textContent = category.textContent; panel.append(h);
          }
          panel.append(...Array.from(content.childNodes));
        });
        if (panel.children.length === 1) {
          const unavailable = document.createElement('p');
          unavailable.textContent = 'Plant highlights are not available for this mix yet. See Seed Mix Specifications for the species list.';
          panel.append(unavailable);
        }
        panel.querySelectorAll('h3').forEach(heading => {
          if (heading === label) return;
          const replacement = document.createElement('h4'); replacement.append(...Array.from(heading.childNodes)); heading.replaceWith(replacement);
        });
        panel.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        panel.hidden = true;
        body.append(panel);
        return panel;
      });
      details.append(summary, body); wrapper.append(details); specs.before(wrapper);
      scope.querySelectorAll('.product__description .nc-prairie-highlights').forEach(node => node.remove());
      const note = document.createElement('p');
      note.className = 'nc-prairie__selection-help';
      note.textContent = this.dataset.optionalBase === 'true'
        ? 'Choose your foundation and any add-on mixes here. Only your selected mixes appear below in Meet the Standout Plants and Seed Mix Specifications, with each mix clearly labeled. Both sections update as you select or remove a mix.'
        : 'This add-on is the selected mix on this page. Its highlights and species appear below in Meet the Standout Plants and Seed Mix Specifications, labeled with the mix name. Choose your coverage here to update the seed amount.';
      const choices = this.querySelector('.nc-prairie__choices');
      if (choices) choices.querySelector('.nc-prairie__hint').after(note);
      else this.form.prepend(note);
    }
    setupAccordionIcons() {
      const scope = this.closest('product-info') || this.parentElement;
      scope.classList.add('nc-prairie-accordions');
      const paths = {
        'Meet the Standout Plants': 'M10 17V9M10 12C4 12 2 8 3 3C8 3 11 6 10 12ZM10 9C10 4 13 2 17 3C18 7 15 10 10 9M6 17H14',
        'Seed Mix Specifications': 'M7 3H4V18H16V3H13M7 2H13V5H7ZM7 9H13M7 12H13M7 15H11',
        'Site fit and mix overview': 'M2 16L7 10L11 14L14 11L18 16ZM13 5A2 2 0 1 0 17 5A2 2 0 1 0 13 5M15 1V2M15 8V9M11 5H12M18 5H19',
        'Compare mix components': 'M2 4H8V16H2ZM12 4H18V16H12ZM4 7H6M4 10H6M4 13H6M14 7H16M14 10H16M14 13H16',
        'Coverage and seed amounts': 'M3 3H17V17H3ZM3 7H6M3 11H6M3 14H6M7 3V6M11 3V6M14 3V6',
        'Restoration approach and value': 'M4 14C2 8 7 3 17 3C17 13 12 18 6 16M3 18L13 8M7 14V10M7 14H11',
        'Planting and ordering': 'M10 18V8M10 12C5 12 3 9 3 5C7 5 10 7 10 12ZM10 9C10 5 13 3 17 3C17 7 14 10 10 9M3 18H17',
        'Seed + Warrior Project Planner': 'M4 3H16V18H4ZM7 2V5M13 2V5M4 7H16M7 10H9M11 10H13M7 14L9 16L13 12'
      };
      scope.querySelectorAll('.product__accordion > details > summary').forEach(summary => {
        const heading = summary.querySelector('.accordion__title');
        if (!heading) return;
        const existing = summary.querySelector('.icon-accordion');
        if (existing) { existing.setAttribute('aria-hidden', 'true'); existing.setAttribute('focusable', 'false'); return; }
        const path = paths[heading.textContent.trim()];
        if (!path) return;
        let title = summary.querySelector('.summary__title');
        if (!title) { title = document.createElement('div'); title.className = 'summary__title'; heading.before(title); title.append(heading); }
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('class', 'icon icon-accordion nc-prairie__heading-icon');
        icon.setAttribute('viewBox', '0 0 20 20');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        const shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        shape.setAttribute('d', path); icon.append(shape); title.prepend(icon);
      });
    }
    updateSelectedHighlights(selected) {
      if (!this.highlightPanels) return;
      this.highlightPanels.forEach((panel, index) => { panel.hidden = !selected.includes(index); });
      this.querySelector('[data-selected-highlights]').hidden = !selected.length;
      this.querySelector('.nc-prairie__selection-details').hidden = !selected.length;
      const reference = this.querySelector('.nc-prairie__reference');
      if (reference) reference.hidden = !selected.includes(0);
    }
    coverageOf(variant) {
      const title = variant?.title?.trim();
      if (title === '1/4 Acre') return 2.5;
      if (title === '3/4 Acre') return 7.5;
      if (title === '1/2 Acre') return 5;
      if (title === '1 Acre') return 10;
      const match = /^(\d+(?:\.\d+)?) Acres?$/i.exec(title || '');
      if (!match) return null;
      const tenths = Number(match[1]) * 10;
      return Number.isInteger(tenths * 10) ? tenths : null;
    }
    selection() {
      const raw = this.querySelector('[name=coverage_size]').value;
      const packet = raw === 'packet';
      const enteredArea = this.querySelector('[name=acreage]').value.trim();
      const numericArea = /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(enteredArea) ? Number(enteredArea) : NaN;
      const tenths = raw === 'quarter' ? 2.5 : raw === 'other' ? Math.round(numericArea * 10) : NaN;
      const validArea = packet || raw === 'quarter' || (raw === 'other' && Number.isFinite(numericArea) && numericArea === tenths / 10 && tenths >= 5 && tenths <= 50);
      const matches = v => packet ? v.title === '1,000 sq ft' : this.coverageOf(v) === tenths;
      const base = validArea ? this.products[0]?.variants?.find(matches) : undefined;
      const quantity = Number(this.querySelector('[name=quantity]').value);
      const selected = this.dataset.optionalBase === 'true' ? Array.from(this.querySelectorAll('[data-addon]:checked'), e => Number(e.dataset.addon)) : [0, ...Array.from(this.querySelectorAll('[data-addon]:checked'), e => Number(e.dataset.addon))];
      const variants = this.products.map((p,i) => i === 0 ? base : (validArea ? p?.variants?.find(matches) : undefined));
      return {base, quantity, selected, variants, validArea, tenths, packet};
    }
    update() {
      if (this.busy) return;
      const otherArea = this.querySelector('[name=coverage_size]').value === 'other';
      const areaInput = this.querySelector('[name=acreage]');
      this.querySelector('[data-acre-control]').hidden = !otherArea;
      areaInput.disabled = !otherArea;
      areaInput.required = otherArea;
      const s = this.selection();
      areaInput.setAttribute('aria-invalid', String(otherArea && !s.validArea));
      this.querySelector('[data-area]').textContent = s.packet ? this.words.packetArea : s.validArea ? `${s.tenths / 10} acre · ${(s.tenths * 4356).toLocaleString()} sq ft` : this.words.invalidArea;

      this.querySelectorAll('[data-addon]').forEach(e => {
        const v = s.variants[Number(e.dataset.addon)];
        e.disabled = !v && !e.checked;
        this.querySelector(`[data-price="${e.dataset.addon}"]`).textContent = v ? this.format.format(v.price / 100) + (!v.available ? ' · ' + (this.words.unavailableShort || this.words.unavailable) : '') : (this.words.unavailableShort || this.words.unavailable);
      });
      const availabilityNote = this.querySelector('[data-availability-note]');
      if (availabilityNote) availabilityNote.hidden = s.variants.every(v => v?.available);
      const valid = s.selected.length > 0 && Number.isSafeInteger(s.quantity) && s.quantity > 0 && s.selected.every(i => s.variants[i]?.available);
      const sum = s.selected.reduce((n,i) => n + (s.variants[i]?.price || 0), 0);
      this.querySelector('[data-total]').textContent = !s.base || !s.selected.length ? '—' : this.format.format(sum * (Number.isSafeInteger(s.quantity) && s.quantity > 0 ? s.quantity : 1) / 100);
      const specs = this.specifications;
      const totals = s.selected.reduce((a,i) => a.map((v,j) => v + specs[i][j]), [0,0,0]);
      const speciesCount = this.querySelector('[data-species-count]');
      if (speciesCount) speciesCount.textContent = `${totals[0]} ${this.words.species}`;
      const supplementOnly = s.selected.length > 0 && (this.dataset.optionalBase !== 'true' || !s.selected.includes(0));
      const supplementNotice = this.querySelector('[data-supplement-notice]');
      if (supplementNotice) supplementNotice.hidden = !supplementOnly;
      const visibleSelection = this.querySelector('[data-selected-visible]');
      if (visibleSelection) visibleSelection.textContent = s.selected.length ? s.selected.map(i => this.products[i].title).join(' + ') : this.words.empty;
      const coverageSummary = this.querySelector('[data-coverage-summary]');
      if (coverageSummary) coverageSummary.textContent = s.validArea && Number.isSafeInteger(s.quantity) && s.quantity > 0 ? `${(s.quantity * (s.packet ? 1000 : s.tenths * 4356)).toLocaleString()} ${this.words.totalCoverage}${supplementOnly ? ' · ' + this.words.supplementCoverage : ''}` : '';
      this.querySelector('[data-specs]').textContent = `${totals[0]} ${this.words.species}; ${totals[1].toFixed(3)} ${this.words.pls}; ${totals[2].toFixed(2)} ${this.words.seeds}`;
      const selectedNames = this.querySelector('[data-selected]');
      if (selectedNames) selectedNames.textContent = s.selected.length ? s.selected.map(i => this.words.names[this.componentIndexes[i]]).join(' + ') : this.words.empty;
      const weight = this.querySelector('[data-total-pls]');
      if (weight) weight.textContent = s.validArea && s.selected.length && Number.isSafeInteger(s.quantity) && s.quantity > 0 ? (totals[1] * (s.packet ? 1000 / 43560 : s.tenths / 10) * s.quantity).toFixed(4) + ' lb PLS' : '—';
      this.renderSelectedRows(s.selected);
      this.updateSelectedHighlights(s.selected);
      this.updateGallery(s.selected);
      this.dispatchEvent(new CustomEvent('nc:seed-plan-context', {bubbles:true}));
      this.button.disabled = !valid || this.uncertain || this.dataset.previewOnly === 'true';
      if (!this.uncertain) this.status.textContent = this.unsupportedInitial ? this.words.unsupportedInitial : !s.selected.length ? this.words.empty : !s.validArea ? this.words.invalidArea : (!s.base ? this.words.unsupported : (valid ? '' : this.words.unavailable));
    }
    updateGallery(selected) {
      if (this.dataset.optionalBase !== 'true') return;
      const signature = selected.slice().sort((a,b) => a-b).join(',');
      const key = {'0':'core','0,1':'expanded','0,1,2':'maximum'}[signature];
      const gallery = document.getElementById('MediaGallery-' + this.dataset.sectionId);
      let galleryNote = gallery?.querySelector('[data-gallery-selection-note]');
      if (gallery && !galleryNote) {
        galleryNote = document.createElement('p');
        galleryNote.dataset.gallerySelectionNote = '';
        galleryNote.className = 'nc-prairie__gallery-selection-note';
        galleryNote.setAttribute('role', 'status');
        gallery.prepend(galleryNote);
      }
      if (galleryNote) {
        galleryNote.hidden = Boolean(key);
        galleryNote.textContent = selected.length ? this.words.galleryMismatch : this.words.galleryEmpty;
      }
      const note = this.querySelector('[data-image-selection-note]');
      if (note) note.hidden = true;
      const previous = this.imageSelection;
      this.imageSelection = signature;
      if (!key || previous === undefined || previous === signature) return;
      const target = gallery?.querySelector('[data-prairie-key="' + key + '"]');
      if (target && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(target.dataset.mediaId, false, { preventScroll: true });
    }

    renderSelectedRows(selected) {
      const host = this.querySelector('[data-selected-table]');
      if (!host) return;
      const detail = this.querySelector('[data-selected-details]');
      if (detail) detail.hidden = !selected.length;
      const unique = new Map();
      selected.forEach(i => {
        const component = this.componentIndexes[i];
        (this.recipeRows[component] || []).forEach(row => {
          const key = row.scientific.trim().toLowerCase();
          const value = unique.get(key) || {common:row.common,scientific:row.scientific,url:row.url,origins:[],lbs:0,seeds:0,seedsKnown:true};
          value.origins.push(this.words.names[component]); value.lbs += Number(row.lbs);
          const density = row.seeds == null || String(row.seeds).trim() === '' ? NaN : Number(row.seeds);
          value.seedsKnown = value.seedsKnown && Number.isFinite(density) && density >= 0;
          if (Number.isFinite(density) && density >= 0) value.seeds += density;
          unique.set(key,value);
        });
      });
      const table = document.createElement('table');
      table.style.minWidth = '62rem';
      host.tabIndex = 0;
      host.setAttribute('role', 'region');
      host.setAttribute('aria-label', 'Selected species specifications. Scroll horizontally to view all columns.');
      const head = table.createTHead().insertRow();
      [...(this.words.headers || []), '% of selected seed count'].forEach(label => { const th=document.createElement('th'); th.scope='col'; th.textContent=label; head.append(th); });
      const body = table.createTBody();
      const seedTotal = Array.from(unique.values()).reduce((n,row) => n + row.seeds, 0);
      const percentagesKnown = seedTotal > 0 && Array.from(unique.values()).every(row => row.seedsKnown);
      this.renderComposition(unique, seedTotal, percentagesKnown);
      unique.forEach(row => {
        const tr = body.insertRow();
        const species = tr.insertCell();
        const label = row.common + ' (' + row.scientific + ')';
        if (row.url && row.url.startsWith('https://naturalcommunities.net/products/')) {
          const link = document.createElement('a'); link.href = row.url; link.textContent = label; species.append(link);
        } else species.textContent = label;
        const percentage = percentagesKnown ? row.seeds / seedTotal * 100 : null;
        const percentageLabel = percentage === null ? 'Not available' : percentage > 0 && percentage < 0.01 ? '<0.01%' : percentage.toFixed(2) + '%';
        [row.origins.join(' + '),row.lbs.toFixed(3),row.seedsKnown ? row.seeds.toFixed(2) : 'Not available',percentageLabel].forEach(value => {tr.insertCell().textContent=value;});
      });
      host.replaceChildren(table);
    }
    renderComposition(rows, seedTotal, percentagesKnown) {
      const table = this.querySelector('[data-selected-table]');
      let summary = this.querySelector('[data-seed-composition]');
      if (!summary) {
        summary = document.createElement('section'); summary.dataset.seedComposition = '';
        summary.setAttribute('aria-label', 'Selected mix composition');
        table.before(summary);
      }
      const title = document.createElement('h3'); title.textContent = 'Selected mix composition';
      const total = document.createElement('p');
      total.textContent = percentagesKnown ? 'Combined selected components: ' + rows.size + ' distinct species · ' + seedTotal.toFixed(2) + ' seeds/sq ft (sum of rounded species rows).' : rows.size ? 'The total seed density or seed-count percentages are unavailable because a species density is missing or the total is zero.' : 'Select a mix to see its seed composition.';
      const groups = new Map(['Grasses','Sedges & rushes','Forbs & flowering shrubs'].map(name => [name, {seeds:0,known:true,count:0}]));
      rows.forEach((row,key) => {
        const name = this.speciesGroups[key] || 'Other / unclassified';
        if (!groups.has(name)) groups.set(name, {seeds:0,known:true,count:0});
        const group = groups.get(name); group.count += 1; group.seeds += row.seeds; group.known = group.known && row.seedsKnown;
      });
      const list = document.createElement('ul');
      groups.forEach((group,name) => {
        const item = document.createElement('li'); item.dataset.seedGroup = name;
        const label = document.createElement('strong'); label.textContent = name + ': ';
        const pct = percentagesKnown ? group.seeds / seedTotal * 100 : null;
        const percent = pct === null ? 'percentage unavailable' : (pct > 0 && pct < 0.01 ? '<0.01' : pct.toFixed(2)) + '% of selected seed count';
        item.append(label, group.count + ' species · ' + (group.known ? group.seeds.toFixed(2) + ' seeds/sq ft' : 'seed density unavailable') + ' · ' + percent);
        list.append(item);
      });
      summary.replaceChildren(title,total,list);
      if (rows.has('amorpha canescens')) {
        const note = document.createElement('p'); note.textContent = 'Forbs & flowering shrubs includes Lead Plant (Amorpha canescens).'; summary.append(note);
      }
    }
    async request(path, body) {
      const response = await fetch(this.dataset.root + path, {method:body ? 'POST' : 'GET', headers:{'Content-Type':'application/json','Accept':'application/json'}, credentials:'same-origin', ...(body ? {body:JSON.stringify(body)} : {})});
      const data = await response.json();
      if (!response.ok) { const error = new Error(data.description || 'Cart request failed'); error.cartResponseReceived = true; throw error; }
      return data;
    }
    async submit() {
      if (this.dataset.previewOnly === 'true' || this.busy || this.button.disabled || !this.form.reportValidity()) return;
      const s = this.selection();
      this.busy = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy','true');
      this.status.textContent = this.words.loading;
      const attempt = crypto.randomUUID();
      let attempted = false;
      let addConfirmed = false;
      try {
        const fresh = await Promise.all(s.selected.map(i => this.request('products/' + encodeURIComponent(this.products[i].handle) + '.js')));
        const current = fresh.map((p,j) => p.variants.find(v => v.id === s.variants[s.selected[j]].id));
        if (current.some(v => !v?.available)) { fresh.forEach((p,j) => { this.products[s.selected[j]] = p; }); throw new Error('Unavailable'); }
        if (current.some((v,j) => v.price !== s.variants[s.selected[j]].price)) {
          fresh.forEach((p,j) => { this.products[s.selected[j]] = p; });
          throw new Error('Price changed');
        }
        attempted = true;
        await this.request('cart/add.js', {items:current.map(v => ({id:v.id,quantity:s.quantity,properties:{'_nc_prairie_attempt':attempt}}))});
        addConfirmed = true;
        const cart = await this.request('cart.js');
        const added = cart.items.filter(v => v.properties?._nc_prairie_attempt === attempt);
        if (added.length !== current.length || added.some(v => v.quantity !== s.quantity) || current.some(v => !added.some(line => line.variant_id === v.id))) throw new Error('Incomplete mix');
        window.location.assign(this.dataset.cart);
      } catch (error) {
        let restored = !attempted;
        if (attempted) {
          try {
            const cart = await this.request('cart.js');
            const lines = cart.items.filter(v => v.properties?._nc_prairie_attempt === attempt);
            for (const line of lines) await this.request('cart/change.js', {id:line.key,quantity:0});
            const after = await this.request('cart.js');
            restored = !after.items.some(v => v.properties?._nc_prairie_attempt === attempt) && (addConfirmed || error.cartResponseReceived || lines.length > 0);
          } catch (_) { restored = false; }
        }
        this.uncertain = !restored;
        this.busy = false;
        this.update();
        this.status.textContent = !attempted ? (error.message === 'Price changed' ? this.words.priceChanged : this.words.preflightFailed) : (restored ? this.words.rolled_back : this.words.failed);
        this.querySelector('[data-review]').hidden = false;
        this.status.focus();
      } finally {
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}






